import { object, string } from 'yup'

const requiredScheme = object().shape({
  field: string().required('thisFieldIsRequired'),
})

export default requiredScheme
